import { TableContainer, TableContainerProps } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ScrollHint from "scroll-hint";

const SCROLL_HINT_CLASS_NAME = "scroll-hint";

export const ScrollableTable = ({
  children,
  ...otherProps
}: TableContainerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(true);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) =>
      setInView(entry.isIntersecting)
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, setInView]);

  useEffect(() => {
    if (inView) {
      // 直ぐに表示してしまうとヒントが表示されないことがあるため0.5秒ディレイをかける
      setTimeout(() => {
        new ScrollHint(`.${SCROLL_HINT_CLASS_NAME}`, {
          i18n: {
            scrollable: "スクロールできます",
          },
        });
      }, 500);
    }
  }, [inView]);

  return (
    <TableContainer
      className={SCROLL_HINT_CLASS_NAME}
      ref={ref}
      sx={{
        "& .scroll-hint-icon": {
          // top: "150px",
          zIndex: 1,
        },
      }}
      {...otherProps}
    >
      {children}
    </TableContainer>
  );
};
